export default (
  state = {
    documentSettingsOptions: [],
    discussionSettingsOptions: [],
    discussionEntrySettingsOptions: [],
    searchSettingsOptions: [],
    listUserListSettingsOptions: [],
    templateSettingsOptions: [],
    reworkSettingsOptions: [],
    requiredReadingSettingsOptions: [],
    knowledgeItemSettingsOptions: [],
    expertQuestionTemplateSettingsOptions: [],
    expertQuestionSettingsOptions: [],
    contentRevisionSettingsOptions: [],
    searchHistorySettingsOptions:[],
  },
  action
) => {
  switch (action.type) {
    case "SET_SELECTION_OPTIONS":
      let options = { expertQuestionSettingsOptions: [] };
      for (let i = 0; i < action.options.length; i++) {
        if (action.options[i].key === "document.settings.options") {
          options.documentSettingsOptions = JSON.parse(
            action.options[i].options
          );
        } else if (action.options[i].key === "discussion.settings.options") {
          options.discussionSettingsOptions = JSON.parse(
            action.options[i].options
          );
          options.expertQuestionSettingsOptions = [
            ...options.expertQuestionSettingsOptions,
            ...JSON.parse(action.options[i].options),
          ];
        } else if (
          action.options[i].key === "discusssionsentry.settings.options"
        ) {
          options.discussionEntrySettingsOptions = JSON.parse(
            action.options[i].options
          );
        } else if (action.options[i].key === "search.settings.options") {
          options.searchSettingsOptions = JSON.parse(action.options[i].options);
        } else if (action.options[i].key === "listuserlist.settings.options") {
          options.listUserListSettingsOptions = JSON.parse(
            action.options[i].options
          );
        } else if (action.options[i].key === "template.settings.options") {
          options.templateSettingsOptions = JSON.parse(
            action.options[i].options
          );
        } else if (action.options[i].key === "rework.settings.options") {
          options.reworkSettingsOptions = JSON.parse(action.options[i].options);
        } else if (
          action.options[i].key === "requiredreading.settings.options"
        ) {
          options.requiredReadingSettingsOptions = JSON.parse(
            action.options[i].options
          );
        } else if (action.options[i].key === "knowledgeitem.settings.options") {
          options.knowledgeItemSettingsOptions = JSON.parse(
            action.options[i].options
          );
        } else if (
          action.options[i].key === "expertquestiontemplate.settings.options"
        ) {
          options.expertQuestionTemplateSettingsOptions = JSON.parse(
            action.options[i].options
          );
        } else if (
          action.options[i].key === "expertquestion.settings.options"
        ) {
          options.expertQuestionSettingsOptions = [
            ...options.expertQuestionSettingsOptions,
            ...JSON.parse(action.options[i].options),
          ];
        } else if (
          action.options[i].key === "contentrevision.settings.options"
        ) {
          options.contentRevisionSettingsOptions = JSON.parse(
            action.options[i].options
          );
        } else if (
          action.options[i].key === "searchhistory.settings.options"
        ) {
          options.searchHistorySettingsOptions = JSON.parse(
            action.options[i].options
          );
        }
      }
      return Object.assign({}, state, {
        ...options,
      });
    default:
      return state;
  }
};
